import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" {...props}>
        <Path
            stroke="#6D707C"
            strokeWidth={2}
            d="M16 3C10.477 3 6 7.477 6 13a9.989 9.989 0 0 0 4.33 8.238h11.34A9.989 9.989 0 0 0 26 13c0-5.523-4.477-10-10-10ZM20 25a4 4 0 0 1-8 0"
        />
        <Path
            stroke="#6D707C"
            strokeWidth={2}
            d="M9.5 21.571c0-.066 0-.1.003-.127a.5.5 0 0 1 .441-.44c.028-.004.061-.004.127-.004H21.93c.066 0 .1 0 .127.003a.5.5 0 0 1 .44.441c.004.028.004.061.004.127 0 .398 0 .598-.019.765a3 3 0 0 1-2.645 2.645c-.167.019-.366.019-.765.019H12.93c-.399 0-.598 0-.765-.019a3 3 0 0 1-2.645-2.645c-.019-.167-.019-.366-.019-.765Z"
        />
    </Svg>
);
export { SvgComponent as BellIcon };
